import { Container } from '@mui/system'
import React from 'react'
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import LockIcon from '@mui/icons-material/Lock';
import styled from 'styled-components';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const DesktopBannerContainer = styled.div`
    width: 1200px;
    margin: 0 auto;
    height: 250px;

    display: flex;
    justify-content: space-between;
    align-items: center;
`

const DesktopCard = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const BorderLine = styled.div`
    height:50px;
    width:1px;
    background-color: #eee;
`

const TabletBannerContainer = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    height: 175px;
    padding: 0px 20px;

    display: flex;
    justify-content: space-between;
    align-items: center;
`

const TabletCard = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const MobileBannerContainer = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    height: 250px;
    display: flex;
    justify-content: space-around;
    font-size: 12px;
`

const FlexRow = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;


const MobileCard = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 1rem 0;
`;

const Banner = () => {

    const theme = useTheme()

    const isXs= useMediaQuery(theme.breakpoints.down('xs'));
    const isSm= useMediaQuery(theme.breakpoints.down('sm'));
    const isMd= useMediaQuery(theme.breakpoints.down('md'));
    const isLg= useMediaQuery(theme.breakpoints.down('lg'));
    const isXl= useMediaQuery(theme.breakpoints.down('xl'));


    const desktop = () => (
        <DesktopBannerContainer>
            <DesktopCard className="card">
                <LocalShippingIcon color="primary" fontSize="large"/>
                <p>Free shipping over 100$</p>
            </DesktopCard>
            <BorderLine/>
            <DesktopCard className="card">
                <Inventory2Icon color="primary" fontSize="large"/>
                <p>Free return</p>
            </DesktopCard>
            <BorderLine/>
            <DesktopCard className="card">
                <TrackChangesIcon color="primary" fontSize="large"/>
                <p>Real time order tracking</p>
            </DesktopCard>
            <BorderLine/>
            <DesktopCard className="card">
                <LockIcon color="primary" fontSize="large"/>
                <p>Extra warranty option</p>
            </DesktopCard>
        </DesktopBannerContainer>
    )

    const tablet = () => (
        <TabletBannerContainer>
            <TabletCard className="card">
                <LocalShippingIcon color="primary" fontSize="large"/>
                <p>Free shipping over 100$</p>
            </TabletCard>
            <TabletCard className="card">
                <Inventory2Icon color="primary" fontSize="large"/>
                <p>Free return</p>
            </TabletCard>
            <TabletCard className="card">
                <TrackChangesIcon color="primary" fontSize="large"/>
                <p>Real time order tracking</p>
            </TabletCard>
            <TabletCard className="card">
                <LockIcon color="primary" fontSize="large"/>
                <p>Extra warranty option</p>
            </TabletCard>
        </TabletBannerContainer>
    )


    const mobile = () => (
        <MobileBannerContainer>
            <FlexRow>
            <MobileCard className="card">
                <LocalShippingIcon color="primary" fontSize="large"/>
                <p>Free shipping over 100$</p>
            </MobileCard>
            <MobileCard className="card">
                <Inventory2Icon color="primary" fontSize="large"/>
                <p>Free return</p>
            </MobileCard>
            </FlexRow>
            <FlexRow>
            <MobileCard className="card">
                <TrackChangesIcon color="primary" fontSize="large"/>
                <p>Real time order tracking</p>
            </MobileCard>
            <MobileCard className="card">
                <LockIcon color="primary" fontSize="large"/>
                <p>Extra warranty option</p>
            </MobileCard>
            </FlexRow>
        </MobileBannerContainer>
    )


  return (
    <div>
        {
        (isXs) ?  mobile() : 
        (isSm) ?  mobile() :
        (isMd) ?  tablet() :
        desktop()
      }
    </div>
  )
}

export default Banner